import React from 'react';
import PageLayout from '../../components/layout/PageLayout';
import ContactHero from './components/ContactHero';
import ContactPathways from './components/ContactPathways';
import LeadershipContact from './components/LeadershipContact';
import ProjectInquirySystem from './components/ProjectInquirySystem';
import OfficeLocations from './components/OfficeLocations';
import ResourceRequest from './components/ResourceRequest';
import ContactFAQ from './components/ContactFAQ';

const ContactEngagement = () => {
  return (
    <PageLayout
      title="Contact Us - Get in Touch"
      description="Connect with our team for project inquiries, consultations, and partnership opportunities. Multiple ways to reach us for your telecommunications and engineering needs."
      keywords={['contact', 'consultation', 'project inquiry', 'telecommunications support', 'engineering services']}
    >
      <ContactHero />
      <ContactPathways />
      <LeadershipContact />
      <ProjectInquirySystem />
      <OfficeLocations />
      <ResourceRequest />
      <ContactFAQ />
    </PageLayout>
  );
};

export default ContactEngagement;